export default __webpack_public_path__ + "static/media/kid-9.6eab4177.jpg";